import {
  Autocomplete,
  AutocompletePropsSizeOverrides,
  Box,
  Popper,
  TextField,
  Typography,
} from '@mui/material'
import { OverridableStringUnion } from '@mui/types'
import { useQuery } from '@tanstack/react-query'
import { usersAPI } from 'api/usersAPI'
import { forwardRef } from 'react'

export const AccountManagerSelect = forwardRef<HTMLDivElement, any>(
  function AccountManagerSelect(
    {
      value,
      onChange,
      ...props
    }: {
      value: string
      onChange: (code: string) => void
      props: any
      size:
        | OverridableStringUnion<
            'small' | 'medium',
            AutocompletePropsSizeOverrides
          >
        | undefined
    },
    ref,
  ) {
    // const client = useClient()
    const popper = (props: any) => {
      return <Popper {...props} placement="bottom-start" />
    }
    const { data } = useQuery(['getJyrneyUsers'], async () =>
      usersAPI.getUsersByClientId(1),
    )
    const options = data?.data.value ?? []
    const selectedUser = options.find((user: any) => user.id === value) ?? null

    return data ? (
      <Autocomplete
        ref={ref}
        id="accountManager"
        sx={{ width: 500 }}
        onChange={(_e, option: any | null) => {
          onChange(option ? option.id : '')
        }}
        size={props.size}
        PopperComponent={popper}
        value={selectedUser}
        options={options}
        autoHighlight
        getOptionLabel={(option: any) =>
          option
            ? `${option.firstName} ${option.lastName} - ${option.email}`
            : ''
        }
        renderOption={(props, option) => {
          return (
            <Box
              key={option.id}
              component="li"
              sx={{
                display: 'flex',
                alignItems: 'flex-start !important',
                flexDirection: 'column',
              }}
              {...props}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  gap: '4px',
                }}
              >
                <Typography
                  fontWeight={700}
                  noWrap
                >{`${option.firstName} ${option.lastName}`}</Typography>
                <Typography>{option.email}</Typography>
              </Box>
            </Box>
          )
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              label={'Choose your account manager'}
              inputProps={{
                ...params.inputProps,
                autoComplete: 'off',
              }}
              required={props.required}
              error={props.error}
              helperText={props.helperText}
            />
          )
        }}
      />
    ) : (
      <></>
    )
  },
) as (props: any & { ref?: React.Ref<HTMLDivElement> }) => JSX.Element
